import { ITranslations } from "./interfaces";

export const enTranslations: ITranslations = {
  From: "from",
  LatestArrivals: "latest arrivals",
  LastestArrivalsBreadcrumbs: "Home/Materials/Latest_Arrivals/Blocks",
  ThicknessShort: "thk",
  To: "to",
  Back: "back",
  Material: "material",
  Filters: "filters",
  Finish: "finish",
  Thickness: "thickness",
  ResetFilters: "reset filters",
  SelectLottoBreadcrumbs_p1: "Home/Materials/",
  SelectLottoBreadcrumbs_p2: "/Blocks",
  MaterialType: "material type",
  Color: "color",
  Slabs: "slabs",
  TotalShort: "Tot.",
  QuantityShort: "qty",
  FinishShort: "fin.",
  Optioned: "optioned",
  RequestPackingList: "request packing list",
  PackingList: "packing list",
  Print: "print",
  Lot: "lot",
  Measures: "measures",
  Items: "items",
  Warehouse: "warehouse",
  DownloadImage: "download image",
  ShareLink: "share lot",
  LinkCopiedToClipboard: "link copied to clipboard",
};
